import Axios, { AxiosRequestConfig } from 'axios';

const fetchAsText = (url, options?: AxiosRequestConfig) =>
  Axios.get(url, { responseType: 'text', ...options });
export default fetchAsText;
